import { z } from "zod";
import { meUserSchema } from "../me";

export const loginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const checkEmailRequestSchema = z.object({
  email: z.string().email(),
});
export type CheckEmailRequest = z.infer<typeof checkEmailRequestSchema>;

export const completeProfileRequestSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  phone: z.string().regex(/^\+\d{6,15}$/),
});
export type CompleteProfileRequest = z.infer<typeof completeProfileRequestSchema>;

export const authResponseSchema = z.object({
  token: z.string(),
  user: meUserSchema,
});
export type AuthResponse = z.infer<typeof authResponseSchema>;

export const checkEmailResponseSchema = z.object({
  available: z.boolean(),
});
export type CheckEmailResponse = z.infer<typeof checkEmailResponseSchema>;
